<template>
  <div class="col-12 pb-2 pb-md-5 filter-container">
    <StoCscFilterHeader />
    <StoCscFilterSectionScreed addContainerClasses="py-3" />
    <StoCscFilterSectionInsulation addContainerClasses="py-3 border-top" />
    <StoCscFilterUnderfloorHeating addContainerClasses="py-3 border-top" />
    <StoCscFilterSoundInsulation addContainerClasses="py-3 border-top" />
    <StoCscFilterSectionFill addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionWoodenPanel addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionSupportingStructure addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionSuspendedCeiling addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionImpactSoundLevel addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionSoundReductionIndex addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionHeatTransferCoefficient addContainerClasses="pt-3 border-top" />
    <StoCscFilterSectionFireResistance addContainerClasses="pt-3 border-top" />
  </div>
</template>

<script>

import StoCscFilterHeader from './Header.vue'
import StoCscFilterSectionScreed from './Section/Screed.vue'
import StoCscFilterUnderfloorHeating from './Section/UnderfloorHeating.vue'
import StoCscFilterSoundInsulation from './Section/SoundInsulation.vue'
import StoCscFilterSectionInsulation from './Section/Insulation.vue'
import StoCscFilterSectionFill from './Section/Fill.vue'
import StoCscFilterSectionWoodenPanel from './Section/WoodenPanel.vue'
import StoCscFilterSectionSupportingStructure from './Section/SupportingStructure.vue'
import StoCscFilterSectionSuspendedCeiling from './Section/SuspendedCeiling.vue'
import StoCscFilterSectionImpactSoundLevel from './Section/ImpactSoundLevel.vue'
import StoCscFilterSectionSoundReductionIndex from './Section/SoundReductionIndex.vue'
import StoCscFilterSectionHeatTransferCoefficient from './Section/HeatTransferCoefficient.vue'
import StoCscFilterSectionFireResistance from './Section/FireResistance.vue'

export default {
  name: 'StoCscFilterGrid',
  components: {
    StoCscFilterHeader,
    StoCscFilterSectionScreed,
    StoCscFilterUnderfloorHeating,
    StoCscFilterSoundInsulation,
    StoCscFilterSectionInsulation,
    StoCscFilterSectionFill,
    StoCscFilterSectionWoodenPanel,
    StoCscFilterSectionSupportingStructure,
    StoCscFilterSectionSuspendedCeiling,
    StoCscFilterSectionImpactSoundLevel,
    StoCscFilterSectionSoundReductionIndex,
    StoCscFilterSectionHeatTransferCoefficient,
    StoCscFilterSectionFireResistance,
  },
  mounted () {
    const scrollIntoView = this.$cookies.get('sto-dk-intoview')
    const el = document.querySelector('.filter-header')
    if (el && scrollIntoView) {
      el.scrollIntoView()
    }
    if (this.$cookies.get('cwcc_functional')) this.$cookies.set('sto-dk-intoview', true, 'Fri, 31 Dec 9999 23:59:59 GMT')
  }
}

</script>
